// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading--NqodH61uTmDAY4y2d_dH"};